var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.5C5.78125 0.5 4.64453 0.810547 3.58984 1.43164C2.57031 2.01758 1.76758 2.82031 1.18164 3.83984C0.560547 4.89453 0.25 6.03125 0.25 7.25C0.25 8.46875 0.560547 9.60547 1.18164 10.6602C1.76758 11.6797 2.57031 12.4883 3.58984 13.0859C4.64453 13.6953 5.78125 14 7 14C8.21875 14 9.35547 13.6953 10.4102 13.0859C11.4297 12.4883 12.2383 11.6797 12.8359 10.6602C13.4453 9.60547 13.75 8.46875 13.75 7.25C13.75 6.03125 13.4453 4.89453 12.8359 3.83984C12.2383 2.82031 11.4297 2.01758 10.4102 1.43164C9.35547 0.810547 8.21875 0.5 7 0.5ZM7 1.625C8.01953 1.625 8.96875 1.88281 9.84766 2.39844C10.6914 2.89062 11.3594 3.55859 11.8516 4.40234C12.3672 5.28125 12.625 6.23047 12.625 7.25C12.625 8.26953 12.3672 9.21875 11.8516 10.0977C11.3594 10.9414 10.6914 11.6094 9.84766 12.1016C8.96875 12.6172 8.01953 12.875 7 12.875C5.98047 12.875 5.03125 12.6172 4.15234 12.1016C3.30859 11.6094 2.64062 10.9414 2.14844 10.0977C1.63281 9.21875 1.375 8.26953 1.375 7.25C1.375 6.23047 1.63281 5.28125 2.14844 4.40234C2.64062 3.55859 3.30859 2.89062 4.15234 2.39844C5.03125 1.88281 5.98047 1.625 7 1.625ZM6.4375 2.75V7.8125H10.375V6.6875H7.5625V2.75H6.4375Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.79fea350f0537aa16fce76a5c5712143.svg";
export { ForwardRef as ReactComponent };